import { render, staticRenderFns } from "./ObjectifGrid.vue?vue&type=template&id=61f0f2fe&scoped=true"
import script from "./ObjectifGrid.vue?vue&type=script&lang=js"
export * from "./ObjectifGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0f2fe",
  null
  
)

export default component.exports